/**
 * @summary Handle messages between nG1 and nGP throw window even
 * @module NG1CommService
 * @mkemberof NG1CommService
 * @memberof UI
 * @since 2/26/16
 * @copyright Copyright (c) 2016 NETSCOUT
 */

const moment = require('moment');
const { XMLParser } = require('fast-xml-parser');
const { map, isNil } = require('lodash');

const nsaModuleCommon = require('./nsa.modulecommon');

function NG1CommService(log) {
    const serviceName = 'nG1CommService';
    const parser = new XMLParser();

    return {
        connect,
    };

    function connect() {
        log.debug(`${serviceName} - nGP is connecting to nG1`);
        if (!nsaModuleCommon.getComRouterWindow()) {
            log.debug(`${serviceName} - nGP is not launched from nG1`);
            return;
        }

        if (window.recieveMessage) {
            log.debug(`${serviceName} - nGP has connected to nG1 already`);
            return;
        }

        window.recieveMessage = receiveMessage;
        nsaModuleCommon.InitCommunication();

        registerCallback();

        log.debug(`${serviceName} - nGP connected to nG1 successful`);
    }

    /* Message received from Module Communicator */
    function receiveMessage(destination, data, subDest) {
        log.debug(`Receive message destination: ${destination}, data: ${data}, subDest: ${subDest}`);
        if (!destination && !data) {
            log.debug(`Ignore message which has no destination and data`);
            return;
        }

        if (data === 'NSACLOSEMOD' || data === 'RECEIVE_FOCUS') {
            log.debug(`Ignore message from nG1:: ${data}`);
            return;
        }

        handleMessage(destination, data);
    }

    function registerCallback() {
        const myID = 'ipmModule';
        const verifiedCallback = new nsaModuleCommon.Message(myID, 'NSAVERIFYCALLBACK', 'NSAVERIFYCALLBACK');
        verifiedCallback.send();
    }

    /* Handle the data received from context ng1ReqParasn */
    function handleMessage(destination, data) {
        log.debug(`Handle message from nG1:: destination: ${destination}, data:  ${data}`);
        if (!isNil(data) && data.indexOf('LaunchFrom') !== -1) {
            // parse the data in XMS format to JSON.
            const ng1Req = parser.parse(data);
            const ng1ReqParas = ng1Req.ROOT.Data;
            const launchFrom = ng1ReqParas.LaunchFrom;
            log.debug(`Launch form: ${launchFrom}`);
            if (launchFrom === 'SERVICE_DEPENDENCY_MAP') {
                gotoRedirect(ng1ReqParas);
            } else {
                log.debug('Unknown drill-down request from nG1');
            }
        } else if (ng1TempToken() != null) {
            gotoDefaultPage();
        } else {
            log.debug(`Ignore messages from nG1:: ${data}`);
        }

        log.debug(`Completion of message handling from nG1:: ${data}`);
    }

    function gotoRedirect(ng1ReqParas) {
        log.debug('Launching Server Page...');
        window.location.href = buildRedirectUrl(ng1ReqParas);
    }

    function gotoDefaultPage() {
        log.debug('Launching landing page...');
        window.location.href = buildPulseLandingPageURL();
    }

    function urlParam(name) {
        const results = new RegExp(`[?&]${name}=([^&#]*)`).exec(window.location.href);
        return results == null ? null : results[1] || 0;
    }

    function ng1TempToken() {
        return urlParam('tempTokenId');
    }

    function nG1TempTokenParam() {
        const token = urlParam('tempTokenId');
        return `tempTokenId=${token}`;
    }

    /* get URL for context ng1ReqParasn (e.g. SDD) */
    function buildRedirectUrl(ng1RequestParams) {
        const { protocol, host } = window.location;

        let url = `${protocol}//${host}/ipm/ng1/redirectTo?`;
        url += map(
            {
                serverIp: ng1RequestParams.ServerIPAddress,
                nPointId: ng1RequestParams.NpointId,
                testId: ng1RequestParams.TestId,
                startTime: ng1RequestParams.StartTime,
                endTime: ng1RequestParams.EndTime,
                timeZone: ng1RequestParams.TimeZone,
                startTimeZone: ng1RequestParams.StartTimeZone,
                endTimeZone: ng1RequestParams.EndTimeZone,
            },
            (val, key) => (isNil(val) ? null : `${key}=${val}`)
        )
            .filter((x) => !!x)
            .join('&');

        url += `&${nG1TempTokenParam()}`;

        log.debug(`Landing Pulse detail page URL : ${url}`);
        return url;
    }

    function buildPulseLandingPageURL() {
        const dt = new Date();
        const enTime = dt.getTime() - 300000; // 5 minutes before
        const stTime = enTime - 3600000; // 60 minutes before
        const timeZone = moment.tz.guess(); // for nG1 builds prior to 6.3.3 which have not time zone passed
        const startDateTz = moment.tz(timeZone).zoneAbbr();
        const endDateTz = startDateTz;

        const { protocol, host } = window.location;
        let url = `${protocol}//${host}/ipm/ng1/landing?`;
        url += `startTime=${stTime}&endTime=${enTime}`;
        url += `&startTimeZone=${startDateTz}&endTimeZone=${endDateTz}&timeZone=${timeZone}`;
        url += `&${nG1TempTokenParam()}`;

        log.debug(`Landing Pulse URL : : ${url}`);
        return url;
    }
}

module.exports = NG1CommService;
